import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {VulnerabilityTypes} from '../../constants/helper';
import {ALPHA} from '../../../../shared/style/color-utils';
import {FOCUS_BLUE} from '../../../../shared/style/colors';

export const VulnerabilityContainer = glamorous.div(
  {
    display: 'flex',
    alignItems: 'center'
  },
  ({extraStyle}) => ({
    ...extraStyle
  })
);

export const Vulnerability = glamorous.span(
  {
    textAlign: 'center',
    minWidth: 25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 7,
    borderRadius: 25,
    padding: '2px 7px',
    fontSize: 12,
    fontWeight: 'bold',
    height: 25,
    ' span > svg ': {
      marginLeft: 5,
      width: 12,
      height: 12
    }
  },
  ({color, extraStyle}) => ({
    color: color ? color : FOCUS_BLUE,
    background: color ? ALPHA(color, 0.1) : ALPHA(FOCUS_BLUE, 0.1),
    '> svg > path': {
      fill: color ? color : FOCUS_BLUE
    },
    ...extraStyle
  })
);

const VulnerabilityChip = ({toggle = false, setToggle = () => {}, item, extraStyle}) => {
  return (
    <VulnerabilityContainer>
      <Vulnerability
        onClick={() => setToggle(!toggle)}
        color={VulnerabilityTypes[item.toUpperCase()].color}
        extraStyle={extraStyle}
      >
        {VulnerabilityTypes[item.toUpperCase()].title}
        <span style={{marginTop: 3}}>{VulnerabilityTypes[item.toUpperCase()].icon}</span>
      </Vulnerability>
    </VulnerabilityContainer>
  );
};

VulnerabilityChip.propTypes = {
  toggle: PropTypes.bool,
  setToggle: PropTypes.func,
  item: PropTypes.any,
  extraStyle: PropTypes.object
};

export default VulnerabilityChip;
